import React, { useState, useEffect } from "react";
import "../Styles/Edit_profile.css";
import Profile_img from "../Images/human_icon.jpg";
import api from "../Api.js";
import { showToast } from "./PopupMessage.jsx";

function EditProfile() {
  const [formData, setFormData] = useState({
    name: "",
    mobile: "",
    email: "",
    photo: "",
  });

  const [previewImage, setPreviewImage] = useState(Profile_img);
  const [imageFile, setImageFile] = useState(null);

  const token = localStorage.getItem("accessToken");

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleImageChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      setImageFile(file);
      setPreviewImage(URL.createObjectURL(file));
    }
  };

  useEffect(() => {
    const getProfileData = async () => {
      try {
        const res = await api.get("/profile", {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });

        if (res.data?.status === true) {
          const customer = res.data.customer;

          setFormData({
            name: customer.name || "",
            mobile: customer.mobile || "",
            email: customer.email || "",
            photo: customer.photo || "",
          });

          if (customer.photo) {
            setPreviewImage(customer.photo);
          }

          showToast("Profile Fetched Successfully", "success");
        }
      } catch (err) {
        console.log(err);
      }
    };

    getProfileData();
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      const payload = new FormData();
      payload.append("name", formData.name);
      payload.append("mobile", formData.mobile);
      payload.append("email", formData.email);

      if (imageFile) {
        payload.append("photo", imageFile);
      }

      const res = await api.post("/profile", payload, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      if (res.data?.status === true) {
        showToast("Profile Updated Successfully", "success");
        window.location.reload();
        
      }
    } catch (err) {
      console.log(err);
    }
  };

  return (
    <div className="editProfile_container">
      <h2 className="editProfile_title">Edit Profile</h2>

      <div className="editProfile_card">
        {/* Profile Image */}
        <div className="editProfile_topSection">
          <div className="editProfile_imageWrapper">
            <img
              src={previewImage}
              alt="profile"
              className="editProfile_image"
            />

            <label className="editProfile_uploadBtn">
              Upload new photo
              <input
                type="file"
                accept="image/*"
                hidden
                onChange={handleImageChange}
              />
            </label>

            <p className="editProfile_imgNote">
              At least 800 × 800 is recommended, JPG or PNG
            </p>
          </div>
        </div>

        <hr className="editProfile_divider" />

        {/* Stats */}
        <div className="editProfile_stats">
          <div className="editProfile_statBox">
            <p>Trips Taken</p>
            <h3>0</h3>
          </div>
          <div className="editProfile_statBox">
            <p>Country Visited</p>
            <h3>0</h3>
          </div>
          <div className="editProfile_statBox">
            <p>Review Given</p>
            <h3>0</h3>
          </div>
        </div>

        {/* Form */}
        <form className="editProfile_form" onSubmit={handleSubmit}>
          <label>Full Name</label>
          <input
            type="text"
            name="name"
            value={formData.name}
            onChange={handleChange}
          />

          <label>Phone No</label>
          <input
            type="text"
            name="mobile"
            value={formData.mobile}
            onChange={handleChange}
          />

          <label>E-mail</label>
          <input
            type="email"
            name="email"
            value={formData.email}
            onChange={handleChange}
          />

          <button type="submit" className="editProfile_saveBtn">
            Save Changes
          </button>
        </form>
      </div>
    </div>
  );
}

export default EditProfile;
